/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompetitionModelListResult } from '../../models/competition-model-list-result';

export interface ApiCompetitionGet$Any$Params {
}

export function apiCompetitionGet$Any(http: HttpClient, rootUrl: string, params?: ApiCompetitionGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
  const rb = new RequestBuilder(rootUrl, apiCompetitionGet$Any.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompetitionModelListResult>;
    })
  );
}

apiCompetitionGet$Any.PATH = '/api/competition';
